export const GrantTypes = {
  BotRegistrySlot: 'BotRegistrySlot',
  VoteSlot: 'VoteSlot',
  LicenseShopStock: 'License.ShopStock',
  LicenseVektorGoggles: 'License.VektorGoggles',
  LicenseLiveView: 'License.LiveView',
  SellbotSeat: 'Seat.Sellbot',
  PlotAclSeat: 'Seat.PlotAcl',
} as const;

export const BOT_LICENSE_NAME_KEYS: Record<string, string> = {
  [GrantTypes.SellbotSeat]: 'BOT_LICENSE_NAME_SELLBOT',
  [GrantTypes.PlotAclSeat]: 'BOT_LICENSE_NAME_PLOTACL',
};

export interface GrantTypeDto {
  type: string;
  kind: string;
  defaultValue: number;
  displayName: string;
  description: string;
}

export interface UserGrantSummaryDto {
  userId: string;
  entries: UserGrantEntryDto[];
}

export interface UserGrantEntryDto {
  type: string;
  kind: string;
  displayName: string;
  description: string;
  effectiveValue: number;
  defaultValue: number;
  used: number;
  remaining: number;
  sources: UserGrantSourceDto[];
}

export interface UserGrantSourceDto {
  grantId: string;
  value: number;
  sourceTenantId: string | null;
  sourceTenantName: string | null;
  createdAt: string;
  note: string | null;
}

export interface TenantGrantSummaryDto {
  tenantId: string;
  entries: TenantGrantEntryDto[];
}

export interface TenantGrantEntryDto {
  type: string;
  kind: string;
  displayName: string;
  description: string;
  poolValue: number;
  assigned: number;
  remaining: number;
  poolGrantId: string | null;
  assignments: TenantGrantAssignmentDto[];
}

export interface TenantGrantAssignmentDto {
  grantId: string;
  userId: string;
  username: string;
  value: number;
  createdAt: string;
}
